/* Rope Seal: product card "+" adds the pre-order (selling plan) to the cart and opens the mini cart. Sept 19 2026 */
(function(){
  document.addEventListener('click', async function(e){
    var b = e.target.closest('[data-rs-preorder]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.classList.contains('is-loading')) return;
    b.classList.add('is-loading');
    try {
      var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.dataset.variant), quantity: 1, selling_plan: Number(b.dataset.plan) }] }) });
      if (!r.ok) throw new Error('add failed');
      var html = await (await fetch(location.pathname + '?rs' + '=' + Date.now())).text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('#xo-cart-mini'), cur = document.querySelector('#xo-cart-mini');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      var cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('xo-cart-size').forEach(function(s){ s.textContent = cart.item_count; });
      var triggers = Array.prototype.slice.call(document.querySelectorAll('xo-modal-trigger[xo-name="cart"]'));
      var t = triggers.find(function(x){ return x.offsetParent; }) || triggers[0];
      if (t) t.click(); else location.href = '/cart';
    } catch (err) {
      location.href = b.dataset.url || '/cart';
    } finally {
      b.classList.remove('is-loading');
    }
  }, true);
})();
